export const uploadImage = (
  onUploadStart: () => void,
  onUpload: () => void,
  onUploadComplete: () => void,
  onUploadError: (error: Error) => void
) => {
  onUploadStart();
  try {
    onUpload();
  } catch (err: any) {
    onUploadError(err);
  } finally {
    onUploadComplete();
  }
};
